module.exports = __webpack_public_path__ + "img/symbol_0.9b05c36b.png";